var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoundscapeBreathingBells = function SvgSoundscapeBreathingBells(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22c6.075 0 11-4.925 11-11S17.075 0 11 0 0 4.925 0 11s4.925 11 11 11M5 10h10a4 4 0 0 1 4 4v.5a3.5 3.5 0 1 1-7 0V14a1 1 0 1 1 2 0v.5a1.5 1.5 0 0 0 3 0V14a2 2 0 0 0-2-2H5a1 1 0 1 1 0-2M4 7a1 1 0 0 1 1-1h6a1 1 0 1 0 0-2h-.5a1 1 0 0 1 0-2h.5a3 3 0 1 1 0 6H5a1 1 0 0 1-1-1m1 7h4a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2"
  })));
};
export default SvgSoundscapeBreathingBells;